import { RootLayout } from "@/components/layout/RootLayout";
import { HeroSection } from "@/components/home/HeroSection";
import { DomainPricingSection } from "@/components/home/DomainPricingSection";
import { FeaturesSection } from "@/components/home/FeaturesSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { CTASection } from "@/components/home/CTASection";

export default function Home() {
  return (
    <RootLayout>
      <div className="min-h-screen">
        <HeroSection />
        <DomainPricingSection />
        <FeaturesSection />
        <TestimonialsSection />
        <CTASection />
      </div>
    </RootLayout>
  );
}